import React from 'react';
import * as R from 'ramda';
import { type IntlShape, injectIntl } from '@atlassian/jira-intl';

import { isColorByCustomFieldOption } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import commonMessagesForColorBy from '@atlassian/jira-portfolio-3-portfolio/src/common/view/color-by-legend/messages';
import {
	colourByOptions,
	DEFAULT_COLOR,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/colours';
import commonMessages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';

import LegendContainer from '../legend-container';
import LegendItem from '../legend-item';
import ColorByItem from './color-by-item';

import type { Props } from './types';

function ColourByLegend({
	intl,
	colorByValue,
	customFields,
	colorByLegends,
	timelineWidth,
}: Props & {
	intl: IntlShape;
}) {
	const messages = {
		...commonMessagesForColorBy,
		issueType: commonMessages.issueType,
		allOtherIssues: commonMessages.allOtherIssues,
		label: commonMessages.label,
	};
	if (R.isEmpty(timelineWidth) || R.isEmpty(colorByLegends)) {
		return null;
	}

	let colorByValueTitle = '';
	if (isColorByCustomFieldOption(colorByValue)) {
		const customField = customFields.find((field) => field.id === Number(colorByValue));
		if (customField) {
			colorByValueTitle = customField.title;
		}
	} else {
		colorByValueTitle = intl.formatMessage(messages[colorByValue]);
	}

	// displaying "All other issues" color option only if the plan is colored by component, issue type, label, priority or custom field
	const showAllOtherIssuesColorLabel =
		colorByValue === colourByOptions.COMPONENT ||
		colorByValue === colourByOptions.ISSUE_TYPE ||
		colorByValue === colourByOptions.LABEL ||
		colorByValue === colourByOptions.PRIORITY ||
		isColorByCustomFieldOption(colorByValue);

	return (
		<LegendContainer title={`${intl.formatMessage(messages.colorBy)} (${colorByValueTitle})`}>
			{showAllOtherIssuesColorLabel && (
				<LegendItem key={0}>
					<ColorByItem color={DEFAULT_COLOR} label={intl.formatMessage(messages.allOtherIssues)} />
				</LegendItem>
			)}

			{colorByLegends.map((colorByLegend, index) => (
				<LegendItem key={index + 1}>
					<ColorByItem color={colorByLegend.color} label={colorByLegend.label} />
				</LegendItem>
			))}
		</LegendContainer>
	);
}

export default injectIntl(ColourByLegend);
